import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LyShadowModule, LyShadowService } from 'alyle-ui/shadow';
import { LyCarouselItemComponent, LyCarousel } from './carousel';
import { CarouselService } from './carousel.service';
var LY_CAROUSEL_DIRECTIVES = [LyCarouselItemComponent, LyCarousel];
var LyCarouselModule = /** @class */ (function () {
    function LyCarouselModule() {
    }
    LyCarouselModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, LyShadowModule],
                    exports: [LY_CAROUSEL_DIRECTIVES],
                    declarations: [LY_CAROUSEL_DIRECTIVES],
                    providers: [LyShadowService, CarouselService]
                },] },
    ];
    /** @nocollapse */
    LyCarouselModule.ctorParameters = function () { return []; };
    return LyCarouselModule;
}());
export { LyCarouselModule };
//# sourceMappingURL=carousel.module.js.map